// src/services/queries/searchQueries.ts

import type { QueryFunction, QueryKey } from "@tanstack/react-query";
import { API_BASE_URL } from "@/services";
import { searchQueryKeys } from "@/constants/queryKeys";
import type { SearchTokensResponse } from "@/types/search";

export type SearchTokensParams = {
  q: string;
  limit?: number;
};

export const fetchSearchTokens: QueryFunction<
  SearchTokensResponse,
  QueryKey
> = async ({ signal, queryKey }) => {
  const [, , params] = queryKey as [string, string, { q: string; limit: number }];
  const query = params.q ?? "";
  const limit = params.limit ?? 10;

  const url = new URL(`${API_BASE_URL}/search/tokens`);
  url.searchParams.set("q", query);
  url.searchParams.set("limit", String(limit));

  const response = await fetch(url.toString(), {
    signal,
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    throw new Error(`Failed to fetch search tokens: ${response.status}`);
  }

  return response.json() as Promise<SearchTokensResponse>;
};

export const searchTokensQueryOptions = (q: string, limit = 10) => ({
  queryKey: searchQueryKeys.tokens(q),
  queryFn: fetchSearchTokens,
  meta: { limit },
});


